import { ExportFormat } from '../types';

interface FormatOption {
  id: ExportFormat;
  label: string;
  icon: string;
  description: string;
  badge?: string;
}

const FORMATS: FormatOption[] = [
  {
    id: 'static',
    label: 'Static Image',
    icon: 'ri-image-2-line',
    description: 'Exports your creative as a flat PNG or JPG file. Fast and universally compatible.',
  },
  {
    id: 'video',
    label: 'Video Export',
    icon: 'ri-video-line',
    description: 'Renders an MP4 video with all enabled animations playing. Best for Story and TikTok placements.',
    badge: 'Recommended',
  },
  {
    id: 'pack',
    label: 'Full Export Pack',
    icon: 'ri-archive-2-line',
    description: 'Exports creative files plus your ad copy, CTA text, and a platform upload guide in one ZIP.',
    badge: 'Most Complete',
  },
];

interface ExportFormatProps {
  value: ExportFormat;
  onChange: (v: ExportFormat) => void;
}

export default function ExportFormatSection({ value, onChange }: ExportFormatProps) {
  return (
    <div className="bg-stone-900 border border-stone-800 rounded-xl p-5 mb-4">
      <h3 className="text-sm font-semibold text-white mb-4">Export Format</h3>
      <div className="flex flex-col gap-2">
        {FORMATS.map((f) => {
          const isActive = value === f.id;
          return (
            <button
              key={f.id}
              onClick={() => onChange(f.id)}
              className={`flex items-start gap-4 px-4 py-3.5 rounded-xl border text-left transition-all duration-200 cursor-pointer ${
                isActive
                  ? 'bg-orange-500/10 border-orange-500/60 ring-1 ring-orange-500/30'
                  : 'bg-stone-800/40 border-stone-700/60 hover:border-stone-600'
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg shrink-0 mt-0.5 ${isActive ? 'bg-orange-500/20' : 'bg-stone-800'}`}>
                <i className={`${f.icon} text-base ${isActive ? 'text-orange-400' : 'text-stone-400'}`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-sm font-semibold ${isActive ? 'text-white' : 'text-stone-300'}`}>{f.label}</span>
                  {f.badge && (
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      isActive ? 'bg-orange-500/30 text-orange-300' : 'bg-stone-700 text-stone-400'
                    }`}>
                      {f.badge}
                    </span>
                  )}
                </div>
                <p className="text-xs text-stone-500 leading-relaxed">{f.description}</p>
              </div>
              <div className={`w-5 h-5 flex items-center justify-center rounded-full border shrink-0 mt-0.5 ${
                isActive ? 'bg-orange-500 border-orange-500' : 'border-stone-600'
              }`}>
                {isActive && <i className="ri-check-line text-white text-xs" />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
